import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { requestClientTagsData } from 'reducers/monitor/tags/actions';

import { tagsData, addNewTag, removeTag, editTag, assignTag, unassignTag } from './types';

import {
  requestClientTagsDataSuccess,
  requestClientTagsDataFailure,
  requestDeleteClientTagSuccess,
  requestDeleteClientTagFailure,
  requestAddClientTagSuccess,
  requestAddClientTagFailure,
  requestAssignTagSuccess,
  requestAssignTagFailure,
  requestUnassignTagSuccess,
  requestUnassignTagFailure,
} from './reducer';

import { unassignEntityTag, assignEntityTag } from '../overview/reducer';

const logger = new Logger('Saga:Monitor');

export function* requestTagsDataSaga() {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(authApiService.get, routerService.generate('api.monitor.tags'));
    yield put(requestClientTagsDataSuccess(response.data));
  } catch (error) {
    logger.info('Failed to get clients tags', error);
    yield put(requestClientTagsDataFailure(error));
  }
}

export function* requestNewTagSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.post,
      routerService.generate('api.monitor.tags'),
      action.payload,
    );
    yield put(requestClientTagsData());
    if (action.promise) action.promise.resolve(response.data);
    yield put(requestAddClientTagSuccess(response.data));
  } catch (error) {
    logger.info('Failed to get clients tags', error);
    if (action.promise) action.promise.reject(error);
    yield put(requestAddClientTagFailure(error));
  }
}

export function* requestRemoveTagSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.delete,
      routerService.generate('api.monitor.tag_edit', { tagId: action.tagId }),
    );
    yield put(requestClientTagsData());
    yield put(requestDeleteClientTagSuccess(response.data));
  } catch (error) {
    logger.info('Failed to delete current tag with following error', error);
    yield put(requestDeleteClientTagFailure(error));
  }
}

export function* requestEditTagSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.patch,
      routerService.generate('api.monitor.tag_edit', { tagId: action.tagId }),
      action.payload,
    );
    yield put(requestClientTagsData());
    yield put(requestAddClientTagSuccess(response.data));
  } catch (error) {
    logger.info('Failed to get clients tags', error);
    yield put(requestAddClientTagFailure(error));
  }
}

export function* requestAssignTagSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.post,
      routerService.generate('api.monitor.tag_assign', { entityId: action.entityId }),
      action.payload,
    );
    yield put(
      assignEntityTag(action.entityId, { ...response.data.tag, assignmentId: response.data.id }),
    );
    yield put(requestAssignTagSuccess(response.data));
  } catch (error) {
    logger.info('Failed to get clients tags', error);
    yield put(requestAssignTagFailure(error));
  }
}

export function* requestUnassignTagSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.delete,
      routerService.generate('api.monitor.tag_unassign', {
        entityId: action.entityId,
        tagId: action.tagId,
      }),
    );
    yield put(unassignEntityTag(action.entityId, action.tagId));
    yield put(requestUnassignTagSuccess(response.data));
  } catch (error) {
    logger.info('Failed to get clients tags', error);
    yield put(requestUnassignTagFailure(error));
  }
}

export default function* clientTagsSaga() {
  return yield all([
    takeLatest(tagsData.request, requestTagsDataSaga),
    takeLatest(addNewTag.request, requestNewTagSaga),
    takeLatest(removeTag.request, requestRemoveTagSaga),
    takeLatest(editTag.request, requestEditTagSaga),
    takeLatest(assignTag.request, requestAssignTagSaga),
    takeLatest(unassignTag.request, requestUnassignTagSaga),
  ]);
}
